exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Example Media queries\n *\n * @media (max-width: @kng-screen-xs-max) { ... }\n * @media (min-width: @kng-screen-sm-min) and (max-width: @kng-screen-sm-max) { ... }\n * @media (min-width: @kng-screen-md-min) and (max-width: @kng-screen-md-max) { ... }\n * @media (min-width: @kng-screen-lg-min) { ... }\n *\n */\n.area-card .kng-cards-image {\n  height: 140px;\n  width: 228px;\n}\n.area-card a {\n  text-decoration: none;\n}\n.area-card .area-status {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n.area-card .kng-cards-info h4 {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  max-width: 180px;\n  margin-bottom: 5px !important;\n}\n.area-card .active-details {\n  margin-bottom: 20px;\n}\n.area-card .kng-cards-item {\n  width: 228px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/areas/card/card.component.less
// module id = ../../../../../src/app/components/areas/card/card.component.less
// module chunks = main